import { createRoute, getPathForAllPortals } from "utilities/flatRoutes/routes";

export const billAddPath = "/BillAdd/:jobId";
export const billAddRoute = createRoute<{ jobId: number }>(
    getPathForAllPortals(billAddPath),
    "Add Bill",
);
